import React from "react"
import styled from 'styled-components'
import { useStaticQuery, graphql } from "gatsby"


const PreviousReadsSection = styled.div `
  margin-top: 1rem;
  border-top: 2px solid #f2f2f2;
  padding: 3rem 0;
`

const SectionLabel = styled.div `
  /* font-family: Lato;
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  color: #000000;
  letter-spacing: 1px; */

  font-size: 1.5rem;
  font-weight: 300;
  text-transform: lowercase;
`

const Book = styled.div `
  margin-top: 2rem;
  display: flex;
  flex-direction: row;
`

const BookCover = styled.div `
  display: block;
  /* flex-basis: 80px; */
  flex: 0 0 auto;
  height: 116px;
  position: relative;

  &:after {
    border: 1px solid rgba(0, 0, 0, 0.1);
    content: '';
  
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`

const BookCoverImg = styled.img `
  margin: 0;
  width: 80px;
  /* height: 116px; */
`

const BookDetails = styled.div `
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  color: #2F4659;
`

const BookTitle = styled.span `
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.4;
  
`

const BookAuthor = styled.span `
  margin-top: 0.5rem;
  font-size: 1rem;
`

const PreviousReadsAside = () => {
  const { allBookshelfYaml } = useStaticQuery(
    graphql`
      query {
        allBookshelfYaml(filter: { status: { eq: "read" } }, limit: 12 ) {
          edges {
            node {
              title
              author
              isbn
              image {
                childImageSharp {
                  fixed(width: 123) {
                    width
                    height
                    src
                    srcSet
                  }
                }
              }
            }
          }
        }
      }
    `
  )

  return (
    <PreviousReadsSection>
      <SectionLabel>Previous Reads</SectionLabel>
      {allBookshelfYaml.edges.map(({ node }) => (  
        <Book>
          <BookCover>
            <BookCoverImg src={node.image.childImageSharp.fixed.src}/>
          </BookCover>
          <BookDetails>
            <BookTitle>
              {node.title}
            </BookTitle>
            <BookAuthor>
              {node.author}
            </BookAuthor>
          </BookDetails>
        </Book>
      ))}
    </PreviousReadsSection>
  )
}

export { PreviousReadsAside }